<template>
  <kbd :class="['inline-flex shrink-0 items-center rounded', toneClass, sizeClass]">
    <slot />
  </kbd>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { TwnKbdProps, TwnKbdSize, TwnKbdTone } from '@/components/atoms/typography/twn-kbd/TwnKbd.types'

const props = withDefaults(defineProps<TwnKbdProps>(), { size: 'sm', tone: 'outlined' })

// `xs` is a keycap inside a button or a row, in px because the 12px root would shrink a rem one;
// `sm` is a key hint in a footer; `md` is a shortcut beside a search box, as the command palette's ⌘+K.
const SIZE_CLASS: Record<TwnKbdSize, string> = {
  xs: 'h-[18px] min-w-[18px] justify-center px-1 font-sans text-[11px] font-medium',
  sm: 'h-5 min-w-5 justify-center px-1 text-surface-600',
  md: 'h-6 px-1.5 text-xs text-surface-500'
}

// Black at 35% darkens any fill in either theme, so the keycap reads on a primary button in light and dark.
const TONE_CLASS: Record<TwnKbdTone, string> = {
  outlined: 'border border-surface-200 bg-surface-0',
  muted: 'bg-surface-100 text-surface-600',
  raised: 'bg-surface-0 text-surface-600',
  'on-fill': 'bg-black/35'
}

const sizeClass = computed(() => SIZE_CLASS[props.size])
const toneClass = computed(() => TONE_CLASS[props.tone])
</script>
